import styled from 'styled-components';

export const Container = styled.div`
background: linear-gradient(315deg, rgba(248, 202, 60, 1) 0%, rgba(252, 13, 117, 1) 27.59%, rgba(27, 27, 26, 1) 90.35%);
`;


export default Container;